import { validate } from 'validate.js'
import { useDispatch } from 'react-redux'

const { useState, useEffect } = require('react')

export const useFormState = (schema, valores) => {
  const dispatch = useDispatch()

  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      ...valores,
    },
    touched: {},
    errors: {},
    isLoading: false,
  })

  const restartForm = () => {
    setFormState({
      isValid: false,
      values: {},
      touched: {},
      errors: {},
      isLoading: false,
    })
  }

  const resetFormValues = (values) => {
    setFormState({
      isValid: false,
      values: {
        ...values,
      },
      touched: {},
      errors: {},
      isLoading: false,
    })
  }

  const handleChange = (event) => {
    event.persist()
    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value,
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true,
      },
    }))
  }

  const handleChangeWithModification = (event, modification) => {
    event.persist()
    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]: modification(event.target.value),
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true,
      },
    }))
  }

  const handleChangeNewValue = (event, newValue) => {
    event.persist()
    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]: newValue,
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true,
      },
    }))
  }

  const handleChangeNewValueByNameProperty = (event, newValue, property) => {
    event.persist()
    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        [property]: newValue,
      },
      touched: {
        ...formState.touched,
        [property]: true,
      },
    }))
  }

  const handleChangeNewValueIdByNameProperty = (event, newValue, property) => {
    event.persist()
    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        [property]: newValue.id,
      },
      touched: {
        ...formState.touched,
        [property]: true,
      },
    }))
  }

  const handleChangeCampoData = (property, valor) => {
    if (valor !== 'Invalid date') {
      setFormState((formState) => ({
        ...formState,
        values: {
          ...formState.values,
          [property]: valor,
        },
        touched: {
          ...formState.touched,
          [property]: true,
        },
      }))
    }
  }

  const handleChangeNumber = (e) => {
    const input = e.target.value
    if (input.match(/^([0-9]{1,})?(\.)?([0-9]{1,})?$/)) {
      handleChange(e)
    }
  }

  useEffect(() => {
    const errors = validate(formState.values, schema)

    setFormState((formState) => ({
      ...formState,
      isValid: !errors,
      errors: errors || {},
    }))
  }, [formState.values])

  const handleSubmit = async (dispatchedFunction) => {
    await dispatch(dispatchedFunction)
  }

  const hasError = (field) => formState.touched[field] && formState.errors[field]

  const hasErrorWithoutTouch = (field) => formState.errors[field]

  return {
    formState,
    setFormState,
    handleChange,
    handleChangeNewValue,
    handleSubmit,
    hasError,
    handleChangeNewValueByNameProperty,
    handleChangeNewValueIdByNameProperty,
    restartForm,
    handleChangeCampoData,
    handleChangeNumber,
    handleChangeWithModification,
    resetFormValues,
    hasErrorWithoutTouch,
  }
}
